import styled from 'styled-components';

export const ColorPreview = styled.div`
  width: 1rem;
  height: 1rem;
  background-color: ${props => props.color || 'transparent'};
  border: 1px solid #000;
  cursor: pointer;
`;
